import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { assignmentStatuses } from "../../constants/index";

const CourseCardReattemptMessage = ({
  assignmentStatus,
  isAbsent,
  postScore,
  passingPostScore,
  passFail
}) => {
  const { t } = useTranslation();
  const retakeMsg =
    assignmentStatus === assignmentStatuses.pending || isAbsent
      ? t("courseCard.courseCardReattemptMessage.retakeMsgForPendingILT")
      : passingPostScore
      ? t("courseCard.courseCardReattemptMessage.retakeMsgWithScore", {
          passingPostScore: passingPostScore
        })
      : t("courseCard.courseCardReattemptMessage.retakeMsgWithNoScore");
  const scoreMsg = isAbsent
    ? t("courseCard.courseCardReattemptMessage.absentMsg")
    : !passFail
    ? t("courseCard.courseCardReattemptMessage.scoreMsg", {
        postScore: postScore
      })
    : "";
  const scoreColor =
    assignmentStatus === assignmentStatuses.failed || isAbsent
      ? "error"
      : "secondary";
  return (
    <Typography variant="body2" color="textSecondary">
      {scoreMsg && (
        <Typography component="span" variant="subtitle2" color={scoreColor}>
          {scoreMsg}
        </Typography>
      )}
      <Typography component="span" variant="body2">
        {retakeMsg}
      </Typography>
    </Typography>
  );
};

export default CourseCardReattemptMessage;

CourseCardReattemptMessage.propTypes = {
  postScore: PropTypes.number,
  passingPostScore: PropTypes.number,
  assignmentStatus: PropTypes.string,
  isAbsent: PropTypes.bool,
  passFail: PropTypes.bool
};
